export interface IUriPathService {
	readonly systemName:string;
	resolvePath(path:string, params?:any):string;
};


/**
* @ngdoc service
* @name  phoenix.pxUriPathService
* 
* @description 
* A service used to construct ShareBase administration URI paths
**/
export function UriPathServiceFactory(
	settingsService, 
	pxAuthService
) {
	// https://regex101.com/r/mAQqZk/1
	const queryStringRegex = /\{\?([\w,]+)\}$/gi;
	// https://regex101.com/r/Biqwua/3
	const absoluteUriRegex = /^(http:|https:|www.)/gi;
	var service = {
		/**
		* @ngdoc method
		* @name pxUriPathService#resolvePath
		* @methodOf phoenix.pxUriPathService
		* @kind function
		*
		* @description
		* Updates the path with the input system name and server API path
		* 
		* @param {object} path A URI path
		*
		* @returns {Deferred} An updated URI path with the server API path appended
		* 
		*/
		resolvePath,

		/**
		* @ngdoc property
		* @name pxUriPathService#systemName
		* @propertyOf phoenix.pxUriPathService
		* @kind property
		*
		* @description
		* A deployment name
		* 
		* @returns {string} A deployment's name
		*/
		get systemName() { return pxAuthService.systemName || ''; }
	};

	return service;

	function resolvePath(path:string, params:any = {}) {
		let qsMatch = queryStringRegex.exec(path);			
		if(qsMatch){
			let qsParams = qsMatch[1].split(',');
			path = path.replace(queryStringRegex, '');
			path += '?' + qsParams
				.filter(key => key in params && angular.isDefined(params[key]))
				.map(key =>  {
					let param = params[key];
					// expand array parameters into "&key=val1&key=val2" format
					if(Array.isArray(param)){
						return param.map(p => `${key}=${p}`).join('&');
					}
					else {
						return `${key}=${params[key]}`;
					}						
				})
				.join('&');
		}

		// a provided system name takes precedence over the default
		params.system = params.system || service.systemName;

		// apply each provided parameter to the path template string 
		Object.keys(params).forEach(function (key) {
			var value = params[key];
			var regex;

			if (angular.isDefined(value) && value !== null) {
				value = value.toString();
				regex = new RegExp('{\s*' + key + '\s*}', 'g');
				
				if (value.length > 0) {
					path = path.replace(regex, value);
				}
			}
		});

		return path.match(absoluteUriRegex) ? path : settingsService.serverAPIPath + path;
	}
}

UriPathServiceFactory.$inject =  [
	'settingsService',
	'pxAuthService'
];


// WEBPACK FOOTER //
// ./src/phoenix/services/uriPathService.ts